import get from 'lodash/get';
import { getCurrentPage, getNextPageParams, getPreviousPageParams } from '../Pager/selectors';
import mustBeNextPageIndexed from '../Pager/utils/mustBeNextPageIndexed';
import mustBePreviousPageIndexed from '../Pager/utils/mustBePreviousPageIndexed';

export function getPreviousPageUrl(state) {
  return mustBePreviousPageIndexed(getCurrentPage(state))
    ? get(getPreviousPageParams(state), ['urls', 'as'])
    : null;
}

export function getNextPageUrl(state) {
  return mustBeNextPageIndexed(getCurrentPage(state))
    ? get(getNextPageParams(state), ['urls', 'as'])
    : null;
}



// WEBPACK FOOTER //
// ./app/Serp/components/shared/HeadMeta/selectors.js